import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export default class ExperimentDisablePaypal {
  static key = 'disable-paypal';

  static variations = {
    control: 'control',
    'disable-paypal': 'true',
  };

  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }

  static isPaypalDisabled(): boolean {
    return this.currentVariant() === this.variations['disable-paypal'];
  }

  static currentVariant(): string {
    return getFullVariant(this.key, {
      value: this.variations.control,
    }).value;
  }
}
